"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectContactData.name': '联系数据检测',
    'tools.detectContactData.description': '自动检测和提取用户消息中的联系信息，如电话号码、电子邮件、地址和姓名',
};
